module.exports = __webpack_public_path__ + "static/img/noactive.9c1793db.svg";